import {
    Directive,
    HostListener,
    ElementRef,
    Optional,
    Self,
    AfterViewInit
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[phoneNumberFormat]'
})
export class PhoneNumberFormatDirective implements AfterViewInit {
    constructor(
        private el: ElementRef,
        @Optional() @Self() private formControl: NgControl
    ) { }

    @HostListener('input', ['$event'])
    onInput(event: Event): void {
        // Allow only digits (0-9), no formatting
        const input = this.formControl.control.value || '';
        const digits = input.replace(/\D/g, '');
        this.updateValue(digits);
    }

    @HostListener('blur')
    onBlur(): void {
        const digits = (this.formControl.control.value || '').replace(/\D/g, '');

        // Format into groups of 3, last group can be 3 or 4
        const formattedValue = this.formatPhoneNumber(digits);
        this.updateValue(formattedValue);
    }

    // To format in case of update/patch
    ngAfterViewInit(): void {
        setTimeout(() => {
            if (this.formControl && this.formControl.control) {
                const controlValue = this.formControl.control.value || '';
                const digits = controlValue.replace(/\D/g, '');
                const formatted = this.formatPhoneNumber(digits);
                this.updateValue(formatted);
            }
        }, 200);
    }

    private formatPhoneNumber(digits: string): string {
        if (digits.length <= 3) return digits; // No grouping needed

        let formatted = '';
        let i = 0;

        // Split into groups of 3, but allow last group to be 3 or 4
        while (i < digits.length) {
            const remaining = digits.length - i;
            let groupSize = 3;

            // Last group can be 3 or 4 digits (but at least 3)
            if (remaining <= 4 && remaining !== 3) {
                groupSize = remaining;
            }

            formatted += digits.substring(i, i + groupSize);
            i += groupSize;

            if (i < digits.length) {
                formatted += ' ';
            }
        }

        return formatted;
    }

    private updateValue(val: string): void {
        if (this.formControl?.control) {
            this.formControl.control.setValue(val, { emitEvent: false });
        }
    }
}